import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SetAreaService {
  /**
   * Subject dark mode
   */
  private setAreaSubject = new BehaviorSubject<any>(null as any);

  /**
   * stateObservable
   */
  setAreaData = this.setAreaSubject.asObservable();

  /**
   * Service constructor
   */
  constructor() {}

  /**
   * Method that handles when  a option is tuner iff
   */
  handleSetArea(type: any): void {
    const data = {
      option: type,
    };
    this.setAreaSubject.next(data);
  }
}
